import { array, partial } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import {
	WholeHouseFoundationRefItem,
	WholeHouseFoundationBasementRefItem,
	WholeHouseFramingRefItem,
	WholeHouseDecksAndPorchesRefItem,
	WholeHouseExteriorFinishesRefItem,
	WholeHouseEwpFloorRoofLayoutRefItem,
	WholeHouseInteriorFinishesRefItem,
	WholeHouseDimensionalFloorRoofLayoutRefItem,
	WholeHouseOpeningsRefItem,
	WholeHouseRoofingRefItem,
	WholeHouseFlatRoofingRefItem,
} from './RefItem';

export const StructuredRefs = partial({
	wholeHouseFoundation: array(WholeHouseFoundationRefItem),
	wholeHouseFoundationBasement: array(WholeHouseFoundationBasementRefItem),
	wholeHouseFraming: array(WholeHouseFramingRefItem),
	wholeHouseDecksAndPorches: array(WholeHouseDecksAndPorchesRefItem),
	wholeHouseExteriorFinishes: array(WholeHouseExteriorFinishesRefItem),
	wholeHouseEwpFloorRoofLayout: array(WholeHouseEwpFloorRoofLayoutRefItem),
	wholeHouseInteriorFinishes: array(WholeHouseInteriorFinishesRefItem),
	wholeHouseDimensionalFloorRoofLayout: array(WholeHouseDimensionalFloorRoofLayoutRefItem),
	wholeHouseOpenings: array(WholeHouseOpeningsRefItem),
	wholeHouseRoofing: array(WholeHouseRoofingRefItem),
	wholeHouseFlatRoofing: array(WholeHouseFlatRoofingRefItem),

	wholeHouseBlockWork: iotsUtils.neverDecoder,
	wholeHouseIntFraming: iotsUtils.neverDecoder,
	wholeHouseExtFraming: iotsUtils.neverDecoder,
	wholeHouseFramingMaterial: iotsUtils.neverDecoder,
	wholeHouseFlooring: iotsUtils.neverDecoder,
	wholeHouseWindows: iotsUtils.neverDecoder,
	wholeHouseDoors: iotsUtils.neverDecoder,
	wholeHouseCeilings: iotsUtils.neverDecoder,
	wholeHouseInsulation: iotsUtils.neverDecoder,
	wholeHouseEavesSoffits: iotsUtils.neverDecoder,
	wholeHouseGutters: iotsUtils.neverDecoder,
	wholeHouseDrywall: iotsUtils.neverDecoder,
	wholeHouseMillwork: iotsUtils.neverDecoder,
	wholeHouseIntWallCladding: iotsUtils.neverDecoder,
	wholeHouseExtWallCladding: iotsUtils.neverDecoder,
	wholeHouseIntFixtures: iotsUtils.neverDecoder,
	wholeHouseFireRatedSystems: iotsUtils.neverDecoder,
	wholeHouseHardware: iotsUtils.neverDecoder,
});
